
    // Register the sample-pre-cache service worker on page load.
    // Runs before the user clicks Start so the cache populates while
    // the user reads the splash text.
    import { initSampleCache } from '/src/sw-register.js';
    initSampleCache();
    // Inject the donate QR code into the donate panel. The QR asset
    // is bundled by Vite (with content hash) and lives at dist/assets/.
    import '/src/assets/qr-import.js';
    // Apply translations to static HTML elements marked with
    // data-i18n attributes. Re-applies on every locale change.
    import '/src/i18n-dom.js';
  